import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        backgroundColor: props.colors.dirtyWhite,
      },
      generalContainer: {},
      infoContainer: {
        marginTop: 24,
        paddingHorizontal: 30,
        marginHorizontal: 30,
        backgroundColor: props.colors.white,
        borderRadius: 20,
        borderWidth: 1,
        borderColor: props.colors.extraLight,
      },

      saveButtonTextColor: {
        color: props.colors.white
      },

      saveButtonStyle: {
        backgroundColor: props.colors.cornflowerBlue,
        width: 308,
        height: 52,
        alignSelf: 'flex-start',
      },

      inputContainer: {
        flex: 1,
        maxWidth: 420,
      },

      inputView: {
        flexDirection: 'row',
        flex: 1, 
        maxWidth: 1200,
        gap: 200,
        paddingBottom: 54,
        paddingRight: 10,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {},
    },
  )();
